import React from 'react';
import SectionHeader from '../../../components/SectionHeader';
import ProcessStep from './ProcessStep';
import './ProcessSection.css';

interface Step {
  number: string;
  title: string;
  description: string;
}

interface ProcessSectionProps {
  steps: Step[];
}

const ProcessSection: React.FC<ProcessSectionProps> = ({ steps }) => {
  return (
    <section className="process-section">
      <div className="container">
        <SectionHeader
          title="How We Work"
          subtitle="From use case to production, built for how Retail and CPG teams operate"
        />
        <div className="process-steps">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <ProcessStep {...step} />
              {index < steps.length - 1 && <div className="process-arrow">→</div>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;

